<template>
  <div class="home" :style="{ minHeight: bodyHeight + 'px' }">
    <!-- <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper> -->
    <router-view></router-view>
    <div class="copyright">版权所有© 国药励展展览有限责任公司</div>
  </div>
</template>

<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
let banner1 = require("../../../../static/img/banner.png");
let banner2 = require("../../../../static/img/banner2.png");
export default {
  name: "ex-register",
  components: {
    gSwiper,
  },
  props: {},
  data() {
    return {
      arr: [
        { id: 1, path: banner1 },
        { id: 2, path: banner2 },
      ],
      bodyHeight: "800px",
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {
    this.bodyHeight = window.innerHeight ? window.innerHeight : "800";
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.home {
  background: #fff;
}
.copyright {
  margin: 0 auto;
  padding-bottom: 64px;
  text-align: center;
  font-size: 12px;
  color: #999;
  padding: 0 20px 30px;
}
</style>
